const baseFitmentFields = ['Year', 'Make', 'Model'];
const extraFitmentFields = [];
const wheelsFields = ['wheel_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_aspect', 'tire_height', 'tire_rim'];
const ignoreFields = [...wheelsFields, ...tiresFields];

const categorySelectionPageUrl = '/categories/';
const brandSelectionPageUrl = '/brands/';

window.stickyScroll = () => {
  const ymmContainerEl = document.querySelector('.cm_vehicle-widget-content');

  if (ymmContainerEl) {
    const headerEl = document.querySelector('header');

    const ymmVehicleWidgetEl = document.querySelector('.cm_vehicle-widget__sticky-container');

    if (ymmVehicleWidgetEl) {
      if (window.innerWidth < 801) {
        ymmContainerEl.classList.remove('isSticky');
        ymmVehicleWidgetEl.classList.remove('container');
        ymmContainerEl.style.top = 'auto';
        return;
      }

      const headerHeight = headerEl.clientHeight;
      const ymmStartPos = ymmContainerEl.parentElement.getBoundingClientRect();

      // use "+5" to get a more accurate if check
      if (ymmStartPos.top < headerHeight + 5) {
        ymmContainerEl.classList.add('isSticky');
        ymmVehicleWidgetEl.classList.add('container');
        ymmContainerEl.style.top = `${headerHeight}px`;
      } else {
        ymmContainerEl.classList.remove('isSticky');
        ymmVehicleWidgetEl.classList.remove('container');
        ymmContainerEl.style.top = 'auto';
      }
    }
  }
};

function AfterInit() {
  window.addEventListener('scroll', window.stickyScroll);
  window.addEventListener('resize', window.stickyScroll);
}

export default {
  platform: 'bigcommerce',
  AfterInit,
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  page: {
    getPageType: (defaults) =>
      window.location.pathname === categorySelectionPageUrl ||
      window.location.pathname === brandSelectionPageUrl
        ? 'parts'
        : defaults.getter(),
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'category' },
      { pathname: brandSelectionPageUrl, field: 'brand_name' },
    ],
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: { replace: 'main .page-content' },
      template: 'SearchPage',
      visibleIf: () => window.location.pathname === '/search/',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: '.body .page',
      template: 'SearchPage',
      visibleIf: () =>
        window.document.querySelector(
          '[data-content-region=category_below_header], [data-content-region=brand_below_header]',
        ) &&
        window.location.pathname !== categorySelectionPageUrl &&
        window.location.pathname !== brandSelectionPageUrl,
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'form-select',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
    },
    { name: 'SearchResult' },
    {
      name: 'SearchBox',
      location: '.header-search',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: { selector: '.quick-search-container' },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 550,
    },
    {
      name: 'HeaderVehicleWidget_garage',
      type: 'VehicleWidget',
      location: {
        replace: '#vehicle-list',
        id: 'vehicle-list',
        class: 'cm_vehicle-widget__garage',
      },
      template: 'fitmentSearch/collapsibleSingleVehicleGarage',
      initCollapsed: true,
      isAlwaysColumnLayout: true,
    },
    {
      name: 'Garage',
      location: '#cm-garage',
      template: 'fitmentSearch/garage',
    },
    {
      name: 'SearchVehicleWidgetGarage',
      type: 'Garage',
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
    },
    {
      name: 'VerifyFitment',
      location: { lastChildOf: '.productView-details.product-options' },
      template: 'fitmentSearch/verifyFitment',
      columnBreakpoint: 550,
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: {
        insertAfter: '.productView-description .tabs li:first-child',
        wrapper: 'li',
        class: 'tab',
      },
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FitmentTable',
      location: {
        lastChildOf: '.productView-description .tabs-contents',
        class: 'tab-content is-closed',
        id: 'tab-fitment',
      },
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '.body .page',
      template: 'facetTiles/hierarchicalContainer',
      visibleIf: () => window.location.pathname === categorySelectionPageUrl,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '.body .page',
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
      visibleIf: () => window.location.pathname === brandSelectionPageUrl,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
      initExpandedFacets: ['category'],
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
